import { documentationActions } from '../../actions/constant';

const { SUCCESS_GET_ALL_CODES_ICD, FAILURE_GET_ALL_CODES_ICD, LOADING_GET_ALL_CODES_ICD } =
  documentationActions;

const intitialstate: object = {
  response: null,
  areGettingCodes: false,
  loading: false,
};

export const getAllICDCodeReducers = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_CODES_ICD: {
      return {
        ...state,
        areGettingCodes: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_GET_ALL_CODES_ICD:
      return {
        ...state,
        areGettingCodes: false,
        response: action.payload,
        loading: true,
      };

    case LOADING_GET_ALL_CODES_ICD:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
